import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { ZoneBadge } from "./shared";

const STATUS = { pending: "text-gold", approved: "text-bull", rejected: "text-bear", expired: "text-slate-500" };

function Suggestion({ s, onChange }) {
  const pending = s.status === "pending";
  const edit = async (pid, v) => {
    try { await client.patch(`/workforce/suggestions/${s.id}`, { partner_id: pid, suggested_share: Number(v) }); onChange(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const decide = async (d) => {
    try { await client.post(`/workforce/suggestions/${s.id}/${d}`); toast.success(d === "approve" ? "Approved — naya lead share lagu" : "Rejected"); onChange(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const total = s.items.reduce((a, i) => a + (i.suggested_share || 0), 0);
  return (
    <div className="surface" data-testid={`wf-sug-${s.id}`}>
      <div className="px-4 py-3 border-b border-[color:var(--border-subtle)] flex items-center gap-2">
        <span className="text-sm text-white">{s.date}</span>
        <span className={`text-[11px] uppercase tracking-wider ${STATUS[s.status]}`} data-testid={`wf-sug-status-${s.id}`}>{s.status}</span>
        {s.decided_by && <span className="text-[11px] text-slate-500">by {s.decided_by}</span>}
        <span className={`ml-auto text-[11px] font-mono ${pending && Math.abs(total - 100) > 1 ? "text-bear" : "text-slate-500"}`} data-testid={`wf-sug-total-${s.id}`}>total {total.toFixed(1)}%{pending && Math.abs(total - 100) > 1 && " — 100% nahi hai"}</span>
      </div>
      <div className="divide-y divide-[color:var(--border-subtle)]">
        {s.items.map((i) => (
          <div key={i.partner_id} className="px-4 py-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
            <span className="text-white min-w-[120px]">{i.name}</span>
            <ZoneBadge zone={i.zone} />
            <span className="text-[11px] text-slate-500 flex-1 min-w-[140px]">{i.reason}</span>
            <span className="font-mono text-slate-400 text-xs">{i.current_share}% →</span>
            {pending ? (
              <input type="number" min="0" max="100" step="0.5" defaultValue={i.suggested_share} onBlur={(e) => Number(e.target.value) !== i.suggested_share && edit(i.partner_id, e.target.value)}
                className="w-20 bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-2 py-1 text-sm font-mono text-white focus:border-gold focus:outline-none" data-testid={`wf-sug-share-${i.partner_id}`} />
            ) : <span className="font-mono text-white text-xs">{i.suggested_share}%</span>}
            {i.action === "suspend" && <span className="text-[11px] text-bear">⛔ suspend {i.suspend_days}d</span>}
          </div>
        ))}
      </div>
      {pending && (
        <div className="p-3 flex gap-2 border-t border-[color:var(--border-subtle)]">
          <button onClick={() => decide("approve")} className="btn-gold px-4 py-2 text-xs flex items-center gap-1" data-testid="wf-sug-approve"><Check size={14} />Approve</button>
          <button onClick={() => decide("reject")} className="px-4 py-2 text-xs border border-[color:var(--border-subtle)] text-slate-300 hover:border-bear hover:text-bear flex items-center gap-1" data-testid="wf-sug-reject"><X size={14} />Reject</button>
        </div>
      )}
    </div>
  );
}

export function SuggestionsTab({ onChange }) {
  const [rows, setRows] = useState(null);
  const load = () => client.get("/workforce/suggestions").then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (!rows) return null;
  if (!rows.length) return <div className="surface p-8 text-center text-sm text-slate-400" data-testid="wf-sug-empty">Abhi koi suggestion nahi. Har raat score ke saath naya suggestion aata hai.</div>;
  return <div className="space-y-3">{rows.map((s) => <Suggestion key={s.id} s={s} onChange={() => { load(); onChange(); }} />)}</div>;
}
